import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@my-env/environment';
import { UserDetails, Users } from '@my-models/users';
import { Constants } from '@my-util/constants';
import { BehaviorSubject, Observable, catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public userInfoSource: BehaviorSubject<UserDetails> =
    new BehaviorSubject<UserDetails>(null!);
  userDetails!: UserDetails;

  constructor(private http: HttpClient, private router: Router) {}

  getUserInfoValue() {
    return this.userInfoSource.value;
  }
  getUserInfo() {
    return this.userInfoSource.asObservable();
  }

  logoutUnauthorized() {
    this.userInfoSource.next(null!);
    this.removeUser();
  }
  logout() {
    this.logoutUnauthorized();
    window.location.href = Constants.LOGIN_ROUTE;
    // this.router.navigate([Constants.LOGIN_ROUTE]);
    return;
    return this.http
      .get<any>(`${environment.crossDomainAPI}/Account/sign-out`)
      .pipe(
        map((data) => {
          this.logoutUnauthorized();
          this.router.navigate([Constants.LOGIN_ROUTE]);
          return data;
        })
      );
  }
  getUser() {
    return JSON.parse(sessionStorage.getItem(Constants.USER_DATA)!);
  }
  isUserLogin() {
    this.userDetails = this.getUser();
    let currDateTime: Date = new Date(Date.now() + 0);
    if (
      this.userDetails != null &&
      this.userDetails.userExpiry != null &&
      new Date(this.userDetails.userExpiry) > currDateTime
    ) {
      return true;
    } else {
      this.removeUser();
    }
    return false;
  }
  private removeUser() {
    sessionStorage.removeItem(Constants.USER_DATA);
    sessionStorage.removeItem(Constants.PREV_URL_KEY);
  }
  private setUser(userDetails: UserDetails, isLogin: boolean = false) {
    if (isLogin) {
      userDetails.userExpiry = new Date(
        Date.now() + (userDetails.expires_in || 21600 * 1000)
      );
      userDetails.location = { lat: 0, lng: 0 };
    }
    sessionStorage.setItem(Constants.USER_DATA, JSON.stringify(userDetails));
  }

  updateUserDetails(userDetails: UserDetails) {
    sessionStorage.setItem(Constants.USER_DATA, JSON.stringify(userDetails));
  }
  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      errorMessage = `Server-side error: ${error.status} ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  crossDomainlogin(formData: Users) {
    return this.http
      .post<any>(`${environment.crossDomainAPI}/Account/SignIn`, formData)
      .pipe(
        map((userDetails) => {
          if (userDetails.statusCode === 200) {
            this.setUser(userDetails.data, true);
          }
          return userDetails;
        })
      );
  }

  getOTP(formData: any) {
    return this.http
      .post<any>(`${environment.crossDomainAPI}/Account/Register`, formData)
      .pipe(catchError(this.handleError));
  }
  verifyOTP(formData: any) {
    return this.http
      .post<any>(`${environment.crossDomainAPI}/Account/VerifyOTP`, formData)
      .pipe(catchError(this.handleError));
  }
  createPassword(formData: any) {
    return this.http
      .post<any>(
        `${environment.crossDomainAPI}/Account/CreatePassword`,
        formData
      )
      .pipe(catchError(this.handleError));
  }
}
